import * as React from "react";
import { Snackbar, Alert } from "@mui/material";

// --- Global Snackbar Component ---
export type SnackbarSeverity = "success" | "error" | "info" | "warning";

export const DEFAULT_MESSAGES: Record<SnackbarSeverity, string> = {
  success: "Done! Saved successfully.",
  error: "Oops. Something went wrong.",
  info: "Heads up.",
  warning: "Please check this.",
};

export interface AppSnackbarrProps {
  open: boolean;
  severity: SnackbarSeverity;
  message?: string;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
}

export default function AppSnackbar({ open, severity, message, onClose }: AppSnackbarrProps) {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        elevation={6}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message ?? DEFAULT_MESSAGES[severity]}
      </Alert>
    </Snackbar>
  );
}